/**
 * Splices one or two random "fun" messages into the announcement marquee,
 * matching pickFun() in src/components/AnnouncementBar.tsx.
 *
 * The core five are already in the DOM from cs-announcement-bar.liquid, so if
 * this never runs the bar still reads correctly — it just stops being funny.
 * The core list is read back out of the DOM rather than duplicated here, so it
 * cannot drift from the Liquid.
 */
(function () {
  const track = document.querySelector('[data-cs-marquee]');
  if (!track) return;

  const FUN = [
    ['🌀', 'Taps for infinite mana'],
    ['🏔️', 'Never miss a land drop again'],
    ['🧙', 'Urza did nothing wrong'],
    ['🐉', 'Counts your bulk faster than a Goblin Welder'],
    ['🪙', 'Untap, upkeep, draw — repeat forever'],
    ['🎲', 'Resolves the stack on the first try'],
    ['🔮', 'Top-decks the answer every time'],
    ['🪄', 'Counters your bulk pile'],
    ['🦉', 'Smarter than a Baral on turn one'],
  ];

  const firstRow = track.querySelector('[data-cs-marquee-row]');
  if (!firstRow) return;
  const core = [...firstRow.children].map((el) => el.outerHTML);

  const item = ([emoji, text]) =>
    '<span class="flex items-center text-xs md:text-sm font-bold uppercase tracking-tight leading-none px-1">' +
    '<span class="inline-block translate-y-[1px] mx-1">' + emoji + '</span>' +
    '<span>' + text + '</span></span>';

  // 1 or 2 fun lines, each spliced in at a random position — pickFun().
  const pool = FUN.slice();
  const out = core.slice();
  const count = 1 + Math.floor(Math.random() * 2);
  for (let i = 0; i < count && pool.length; i++) {
    const [picked] = pool.splice(Math.floor(Math.random() * pool.length), 1);
    out.splice(Math.floor(Math.random() * (out.length + 1)), 0, item(picked));
  }

  const rowHtml = out.join('');
  track.querySelectorAll('[data-cs-marquee-row]').forEach((row) => {
    row.innerHTML = rowHtml;
  });
})();
